<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="px-1"
        v-on="on"
      >
        {{ $t("views.signup_in.password_forgotten") }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">{{
        $t("views.personal_settings.reset_pwd_title")
      }}</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          @submit.prevent=""
        >
          <v-text-field
            validate-on-blur
            :rules="rules.email"
            v-model="email"
            :label="$t('commons.email')"
            @keyup.enter="send"
          />
        </v-form>
      </v-card-text>
      <v-card-text> {{ $t("views.personal_settings.info_how_reset_pwd") }} </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="
            dialog = false
            $refs.form.reset()
          "
        >
          {{ $t("commons.cancel") }}
        </v-btn>
        <v-btn
          class="ma-2"
          color="blue white--text"
          @click="send"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("commons.validate") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AccountService } from "@/services"
import { required, email } from "@/utils/validator"
export default {
  props: {
    text: {
      type: String,
      default: () => "Forgot password?"
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      email: "",
      isFormValid: false,
      rules: {
        email: [required, email]
      }
    }
  },
  methods: {
    send() {
      const self = this
      this.$refs.form.validate()
      this.$nextTick(() => {
        if (this.isFormValid) {
          self.loading = true
          AccountService.resetPassword(self.email, self)
            .then(() => {
              self.dialog = false
            })
            .finally(() => {
              self.loading = false
            })
        }
      })
    }
  }
}
</script>
